import { ConfigInterface } from 'swr';
import { wpAcfV3Api, useWPAcfV3Api, parseUrl } from '@gik/core/api';
import { WordpressFAQItem } from '@gik/core/models/wordpress/WordpressFAQItem';

const path = 'options/options/faq';

export interface IFaqResponse {
  faq: WordpressFAQItem[];
}

export function getFaq() {
  const finalUrl = parseUrl(path, {});
  return wpAcfV3Api.get(finalUrl);
}

export function useFaq(config?: ConfigInterface) {
  return useWPAcfV3Api<IFaqResponse>(path, config, {});
}
